<div class="row align-items-center" [style.background]="mainBackground">
  @if (visibleLogoSection) {
    <div
      class="text-center campaign_page__main__content"
      [ngClass]="diseingMobile ? 'col-12' : 'col-12 col-md-6'"
    >
      @if (selectTextOrImage === 1) {
        <div [innerHTML]="safeTextCampaign"></div>
      } @else {
        <div class="img_campaign_wrapper" [class.is-loaded]="imageLoaded">
          <!-- Loader compacto: se colapsa suavemente cuando llega la imagen -->
          <div
            class="img_campaign_collapse img_campaign_collapse--loader"
            aria-hidden="true"
          >
            <div class="img_campaign_collapse__inner">
              <div class="img_campaign_loader">
                <span></span><span></span><span></span>
              </div>
            </div>
          </div>

          <!-- Contenedor de la imagen: crece desde 0 a su altura real -->
          <div class="img_campaign_collapse img_campaign_collapse--image">
            <div class="img_campaign_collapse__inner">
              <img
                class="img_campaign"
                [class.img_campaign--loaded]="imageLoaded"
                [src]="imageError ? defaultCampaignImage : imageCampaign"
                alt="Campaign Image"
                loading="eager"
                fetchpriority="high"
                decoding="async"
                (load)="onCampaignImageLoad()"
                (error)="onCampaignImageError()"
              />
            </div>
          </div>
        </div>
      }
    </div>
  }

  <div
    class="text-center"
    [ngClass]="diseingMobile ? 'col-12 mt-4' : 'col-12 col-md-6 mt-4 mt-md-0'"
  >
    <div class="credentials_one" #credentialsOne>
      <div
        class="credentials_one__title_container"
        #innerTitle
        [innerHTML]="safeTitle"
      ></div>
      <div
        class="credentials_one__image_wrapper"
        (click)="openFileSelector()"
        [style.pointer-events]="activeButton ? 'auto' : 'none'"
      >
        @if (!avatarLoaded && !croppedImage) {
          <div class="credentials_one__image_skeleton" aria-hidden="true"></div>
        }
        <img
          class="credentials_one__image"
          [class.credentials_one__image--loaded]="avatarLoaded || !!croppedImage"
          [src]="croppedImage || image"
          alt="Avatar"
          loading="lazy"
          decoding="async"
          (load)="onAvatarLoad()"
          (error)="onAvatarError()"
        />
      </div>
      <div class="d-flex flex-column gap-2">
        @if (design === "1") {
          <input
            cFormControl
            type="text"
            id="textInput"
            name="textInput"
            maxlength="30"
            autocomplete="given-name"
            placeholder="Nombre y apellidos"
            [value]="fullName"
            [(ngModel)]="fullNameValue"
            [disabled]="inputFullNameDisabled"
          />
        } @else if (design === "2") {
          <textarea
            cFormControl
            id="textInput"
            name="textInput"
            rows="3"
            maxlength="120"
            placeholder="Escribe como máximo 120 caracteres."
            [(ngModel)]="fullNameValue"
            [disabled]="inputFullNameDisabled"
          ></textarea>
        }
        <input
          type="file"
          id="fileInput"
          class="d-none"
          (change)="fileChangeEvent($event)"
        />
        <button
          cButton
          data-button="buttonUploadProfileBackground"
          (click)="openFileSelector()"
          [style.pointer-events]="activeButton ? 'auto' : 'none'"
        >
          Sube tu foto
        </button>
        <button
          cButton
          data-button="buttonGenerateCredentialBackground"
          [disabled]="loading"
          (click)="createCredential()"
          [style.pointer-events]="activeButton ? 'auto' : 'none'"
        >
          <span class="d-flex align-items-center justify-content-center gap-2">
            @if (loading) {
              <span class="spinner-loader" aria-hidden="true"></span>
              <span>Generando...</span>
            } @else {
              <span>Crear credencial</span>
            }
          </span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ─── Fullscreen Loading Overlay ──────────────────────────── -->
@if (loading) {
  <div class="fullscreen-loader">
    <div class="fullscreen-loader__content">
      <div class="fullscreen-loader__spinner">
        <div class="fullscreen-loader__ring"></div>
        <div
          class="fullscreen-loader__ring fullscreen-loader__ring--inner"
        ></div>
      </div>
      <p class="fullscreen-loader__text">
        Generando credencial<span class="fullscreen-loader__dots"></span>
      </p>
      <p class="fullscreen-loader__subtext">Por favor espera un momento</p>
    </div>
  </div>
}

<c-modal
  id="liveDemoModal"
  class="cropper-modal"
  [visible]="modal"
  alignment="center"
  (visibleChange)="handleLiveDemoChange($event)"
>
  <c-modal-body>
    <image-cropper
      [imageBase64]="imageBase64ForCropper"
      [maintainAspectRatio]="true"
      [aspectRatio]="1 / 1"
      [roundCropper]="true"
      format="jpeg"
      [imageQuality]="80"
      [resizeToWidth]="572"
      [transform]="{ scale: zoom }"
      (imageCropped)="imageCropped($event)"
      style="max-height: 375px"
    >
    </image-cropper>
    <input
      type="range"
      min="1"
      max="3"
      step="0.1"
      [(ngModel)]="zoom"
      class="w-100 mt-2"
    />
  </c-modal-body>
  <c-modal-footer class="justify-content-center">
    <button class="btn btn-cropper-cancel" (click)="cancelCropperImage()">
      Cancelar
    </button>
    <button class="btn btn-cropper-save" (click)="saveCroppedImage()">
      Guardar
    </button>
  </c-modal-footer>
</c-modal>
